import noImageSrc from '../../images/noimage.png';

export class ImageLinkHandler {
  constructor(controller) {
    this.controller = controller;
  }

  initializeImageLinkHandler() {
    this.checkAllImages();
    this.observeNewImages();
  }

  checkAllImages() {
    const images = document.querySelectorAll('img');
    images.forEach(img => this.checkImageAccessibility(img));
  }

  checkImageAccessibility(img) {
    // Skip if already processed
    if (img.dataset.accessibilityChecked) return;

    img.dataset.accessibilityChecked = 'true';

    // Test if image loads successfully
    const testImg = new Image();
    testImg.onload = () => {
      // Image is accessible, no action needed
    };

    testImg.onerror = () => {
      this.replaceWithPlaceholder(img);
    };

    testImg.src = img.src;
  }

  replaceWithPlaceholder(img) {
    const placeholder = document.createElement('div');
    placeholder.className = 'inaccessible-image-placeholder';

    // Get original image dimensions
    const imgWidth = img.offsetWidth || img.width || 200;
    const imgHeight = img.offsetHeight || img.height || 150;

    placeholder.innerHTML = `
      <img src="${noImageSrc}" alt="Image not available" style="width: 100%; height: auto; object-fit: contain;">
    `;

    // Replace the image with placeholder
    img.parentNode.replaceChild(placeholder, img);
  }

  observeNewImages() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.tagName === 'IMG') {
              this.checkImageAccessibility(node);
            } else {
              const images = node.querySelectorAll && node.querySelectorAll('img');
              if (images) {
                images.forEach(img => this.checkImageAccessibility(img));
              }
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}
